import { render, staticRenderFns } from "./manage_events.vue?vue&type=template&id=23a11493&scoped=true"
import script from "./manage_events.vue?vue&type=script&lang=js"
export * from "./manage_events.vue?vue&type=script&lang=js"
import style0 from "./manage_events.vue?vue&type=style&index=0&id=23a11493&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a11493",
  null
  
)

export default component.exports